import axios from 'axios';

// API 주소 결정.
//   값이 설정돼 있으면(빈 문자열 포함) 그대로 쓴다. 빈 문자열은 "같은 오리진" 을 뜻하며,
//   프론트와 API 를 한 도메인에서 서빙하는 배포 환경이 이 경우다.
//   ⚠️ `A || B` 로 쓰면 빈 문자열이 falsy 라 배포본이 사용자 PC 의 localhost 를
//      호출하게 된다. 반드시 undefined 여부로 판단해야 한다.
const configuredBaseURL = process.env.REACT_APP_API_BASE_URL;
const baseURL = configuredBaseURL === undefined ? 'http://localhost:8000' : configuredBaseURL;

const instance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
  }
});

// 요청 인터셉터: 모든 요청에 JWT 토큰 추가
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 응답 인터셉터: 401 에러 시 로그인 페이지로 리다이렉트
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // 토큰이 만료되었거나 유효하지 않음
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default instance;